import './App.css';

function Video() {
    return (
    <div className="Video">
        <div className='flex-container'>
            <h1>Video</h1>


        </div>
    </div>
  );
}

export default Video;
